var map = {
	"./arrow-down.svg": "9c2d",
	"./arrow-up.svg": "681b",
	"./at-solid.svg": "b551",
	"./became-active.svg": "a3df",
	"./bitcoin.svg": "d688",
	"./block.svg": "d7c8",
	"./caret-left.svg": "80e1",
	"./caret-right.svg": "b4f1",
	"./caret.svg": "0223",
	"./chart.svg": "1446",
	"./chat.svg": "8bf7",
	"./check.svg": "06f6",
	"./circle-o.svg": "2a0b",
	"./circle.svg": "e8e5",
	"./copy.svg": "4746",
	"./cross.svg": "42db",
	"./currencies/AUD.svg": "b7a2",
	"./currencies/BRL.svg": "1445",
	"./currencies/BTC.svg": "2d41",
	"./currencies/CAD.svg": "8e4c",
	"./currencies/CHF.svg": "e86e",
	"./currencies/CNY.svg": "8940",
	"./currencies/ETH.svg": "81aa",
	"./currencies/EUR.svg": "8559",
	"./currencies/GBP.svg": "b884",
	"./currencies/INR.svg": "861d1",
	"./currencies/JPY.svg": "37d7",
	"./currencies/KRW.svg": "637d",
	"./currencies/LTC.svg": "9722",
	"./currencies/NZD.svg": "99d6",
	"./currencies/RUB.svg": "50a1",
	"./currencies/USD.svg": "5187",
	"./download.svg": "5ed4",
	"./filter.svg": "b930",
	"./forging.svg": "b148",
	"./globe.svg": "24ec",
	"./group.svg": "e5db",
	"./information.svg": "496c",
	"./key.svg": "dfeb",
	"./known-wallet.svg": "7d5b",
	"./locked-balance.svg": "51b2",
	"./menu.svg": "b28f",
	"./missed-round.svg": "a0fb",
	"./multi-signature.svg": "1f4a",
	"./not-forging.svg": "f7b7",
	"./pagination/first.svg": "07f0",
	"./pagination/last.svg": "3e8f",
	"./pagination/next.svg": "8139",
	"./pagination/previous.svg": "6d48",
	"./qr.svg": "2c19",
	"./search.svg": "2845",
	"./second-passphrase.svg": "4739",
	"./social/bitcointalk.svg": "5b5d",
	"./social/discord.svg": "49cc",
	"./social/email.svg": "1520",
	"./social/facebook.svg": "302c",
	"./social/github.svg": "caf8",
	"./social/instagram.svg": "83f2",
	"./social/medium.svg": "551b",
	"./social/minds.svg": "83b91",
	"./social/reddit.svg": "1b9a",
	"./social/slack.svg": "b93a",
	"./social/soundcloud.svg": "059f",
	"./social/steemit.svg": "c572",
	"./social/telegram.svg": "7880",
	"./social/twitter.svg": "d44d",
	"./social/youtube.svg": "98e5",
	"./tag-outline.svg": "b63d",
	"./tag.svg": "093e",
	"./transaction.svg": "81f5",
	"./verified.svg": "b79b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7769";